module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/create/create.component.scss
// module id = ./src/app/pages/create/create.component.scss
// module chunks = main